/*** IMPORTS FROM imports-loader ***/
var define = false;

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'normalize.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store.js'
import WebFont from 'webfontloader'
import Vector from '@/components/Vector'

WebFont.load({
  // custom: {
  //   families: ['SF Display'],
  //   urls: ['../static/fonts/fonts.css']
  // }
  google: {
    families: ['Roboto:300,400,500']
  },
  classes: false,
  timeout: 2000
})

Vue.config.productionTip = false

Vue.component('vector', Vector)

/* eslint-disable no-new */
new Vue({
  store: store,
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})




// WEBPACK FOOTER //
// ./src/main.js